function parseHex(hex: string): [number, number, number] | null {
  const m = hex.trim().replace('#', '')
  const full = m.length === 3 ? m.split('').map((c) => c + c).join('') : m
  if (full.length !== 6 || !/^[0-9a-f]{6}$/i.test(full)) return null
  return [
    parseInt(full.slice(0, 2), 16),
    parseInt(full.slice(2, 4), 16),
    parseInt(full.slice(4, 6), 16),
  ]
}

function relativeLuminance(rgb: [number, number, number]): number {
  const [r, g, b] = rgb.map((c) => {
    const v = c / 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  }) as [number, number, number]
  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

export function readableOn(bgHex: string): '#000000' | '#FFFFFF' {
  const rgb = parseHex(bgHex)
  if (!rgb) return '#000000'
  return relativeLuminance(rgb) > 0.45 ? '#000000' : '#FFFFFF'
}

function toHex(n: number): string {
  return Math.round(Math.max(0, Math.min(255, n))).toString(16).padStart(2, '0')
}

export function mixColors(aHex: string, bHex: string, weight: number): string {
  const a = parseHex(aHex)
  const b = parseHex(bHex)
  if (!a || !b) return aHex
  const w = Math.max(0, Math.min(1, weight))
  return '#' + toHex(a[0] * (1 - w) + b[0] * w) + toHex(a[1] * (1 - w) + b[1] * w) + toHex(a[2] * (1 - w) + b[2] * w)
}

export function contrastRatio(fgHex: string, bgHex: string): number {
  const a = parseHex(fgHex)
  const b = parseHex(bgHex)
  if (!a || !b) return 1
  const l1 = relativeLuminance(a)
  const l2 = relativeLuminance(b)
  const lighter = Math.max(l1, l2)
  const darker = Math.min(l1, l2)
  return (lighter + 0.05) / (darker + 0.05)
}
